"use strict";
exports.__esModule = true;
exports.chart_color_black_500 = {
  "name": "--pf-v5-chart-color-black-500",
  "value": "#6a6e73",
  "var": "var(--pf-v5-chart-color-black-500, #6a6e73)"
};
exports["default"] = exports.chart_color_black_500;